import Step1 from "./connecting-rhit-1.png";
import Step2 from "./connecting-rhit-2.png";

const connectingImg = [
  {
    id: "Step1",
    imageName: Step1,
    imageDesc: "Connecting on RHIT Laptops Step 1",
  },
  {
    id: "Step2",
    imageName: Step2,
    imageDesc: "Connecting on RHIT Laptops Step 2",
  },
];

export default connectingImg as HelpImage[];
